import React from 'react'
import { Box, Button, Flex, Text } from '@workwhile/ui'
import { TimeClocksHeader } from './TimeClocksHeader'
import { TimeClocksFilters } from './TimeClocksFilters'
import { TimeClocksTable } from './TimeClocksTable'
import { useTimeClocksContextValue } from '../context/TimeClocksProvider'

export const TimeClocksMain = () => {
  const {
    state: { companyId, pageIndex, hasNextPage, hasPrevPage, isFetching },
    actions: { goNextPage, goPrevPage },
  } = useTimeClocksContextValue()

  return (
    <>
      <TimeClocksHeader />
      <Box margin={3}>
        <TimeClocksFilters />
        {companyId === null ? (
          <Text color="lightText">Select a company to view clocks.</Text>
        ) : (
          <>
            <TimeClocksTable />
            {hasPrevPage || hasNextPage ? (
              <Flex mt={3} alignItems="center" justifyContent="center">
                <Button
                  variant="secondary"
                  disabled={!hasPrevPage || isFetching}
                  onClick={goPrevPage}
                >
                  Previous
                </Button>
                <Text mx={3} color="lightText">
                  {`Page ${pageIndex}`}
                </Text>
                <Button
                  variant="secondary"
                  loading={isFetching}
                  disabled={!hasNextPage || isFetching}
                  onClick={goNextPage}
                >
                  Next
                </Button>
              </Flex>
            ) : null}
          </>
        )}
      </Box>
    </>
  )
}
